import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { AgitationSection } from '../components/AgitationSection';
import { MethodSection } from '../components/MethodSection';
import { ResultsSection } from '../components/ResultsSection';
import { IncludesSection } from '../components/IncludesSection';
import { BonusSection } from '../components/BonusSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-309">
      <HeroSection data-id="element-310" />
      <PainSection data-id="element-311" />
      <AgitationSection data-id="element-312" />
      <MethodSection data-id="element-313" />
      <ResultsSection data-id="element-314" />
      <IncludesSection data-id="element-315" />
      <BonusSection data-id="element-316" />
      <TestimonialsSection data-id="element-317" />
      <ForWhoSection data-id="element-318" />
      <GuaranteeSection data-id="element-319" />
      <FAQSection data-id="element-320" />
      <ClosingCTA data-id="element-321" />

      {/* Simple Footer */}
      <footer className="bg-emerald-950 text-emerald-400 py-12 text-center text-sm" data-id="element-322">
        <div className="container mx-auto px-4" data-id="element-323">
          <p className="mb-4" data-id="element-324">
            © 2026 Método 28 Días sin Inflamación. Todos los derechos
            reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-325">
            <a href="#" className="hover:text-white transition-colors" data-id="element-326">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-327">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-328">
              Contacto
            </a>
          </div>
          <p className="mt-8 text-xs text-emerald-600 max-w-2xl mx-auto" data-id="element-329">
            Descargo de responsabilidad: Este producto no sustituye el
            asesoramiento médico profesional. Si tenés condiciones médicas
            preexistentes, consultá a tu médico antes de comenzar cualquier
            cambio en tu alimentación.
          </p>
        </div>
      </footer>
    </div>;
}